import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import IconOneClick from "@/components/icons/IconOneClick.vue";

@Component({
  name: "ActionLogged",
  components: {
    "icon-one-click": IconOneClick,
  },
})
class ActionLogged extends Vue {
  @Prop({ type: String, default: "" })
  readonly title!: string;

  @Prop({ type: Function, default: () => null })
  readonly action!: () => any;

  render() {
    return (
      <btn
        onClick={this.action}
        color="transparent"
        border
        style="width: 100%;"
      >
        <icon-base name="cart" color="#008f85" style="margin-right: 5px">
          <icon-one-click />
        </icon-base>
        {this.title}
      </btn>
    );
  }
}

export default ActionLogged;
